import React, { useState } from 'react';
import axios from 'axios';
import emailjs from '@emailjs/browser';
function Contactuscom() {
   const [emailval, SetEmailval] = useState('');
   const [subjectval, SetSubjectval] = useState('');
   const [messageval, SetMessageval] = useState(''); 
   console.log(emailval);
   function submitform(e){
     e.preventDefault();

     const templateid = "template_g2p9bfk";
     const publickey  = "HxCKrPd2erFx8dHpt";
     const serverid  = "service_xr1t06c";

     const templatedata = {
       from_emailval : emailval,
       from_subjectval : subjectval,
       from_messageval : messageval,
     }

   emailjs.send(serverid, templateid , templatedata, publickey )
    .then(function (response) {
      console.log(response);
      SetEmailval('');
      SetSubjectval('');
      SetMessageval('');
    })
    .catch(function (error) {
      console.log(error);
    });
  }

  return (
    <div>
        <div class="contact-us">
    <div class="py-8 lg:py-16 px-4 mx-auto w-11/12 lg:w-7/12">
        <h2 class="mb-4  tracking-tight font-extrabold text-center text-white">Contact Us</h2>
        <p class=" font-light text-center text-gray-500 dark:text-gray-400 ">Feel free to reach out to discuss collaboration opportunities, project inquiries, or any questions you may have. I'm available via email and LinkedIn.</p>
      
        <form action="#" class="space-y-8" onSubmit={submitform}>
            <div className='sectpad'>
                <label for="email" class="block  font-medium  text-white">Your email</label>
                <input type="email" id="email" class="shadow-sm bg-gray-50 border border-gray-300 text-gray-900  rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light" placeholder="name@flowbite.com" value={emailval} onChange={(e) => SetEmailval(e.target.value) }  required />
            </div>
            <div className='sectpad'>
                <label for="subject" class="block  text-sm font-medium  text-white">Subject</label>
                <input type="text" id="subject" class="block p-3 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 shadow-sm focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light" placeholder="Let us know how we can help you" value={subjectval}  onChange={(e) => SetSubjectval(e.target.value) }   required />
            </div>
            <div class="sm:col-span-2 className='sectpad">
                <label for="message" class="block  text-sm font-medium  text-white">Your message</label>
                <textarea id="message" rows="4" class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg shadow-sm border border-gray-300 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500" placeholder="Leave a comment..."  value={messageval}  onChange={(e) => SetMessageval(e.target.value) }  ></textarea>
            </div>
            <button type="submit" class="py-3 px-5 text-black hover:text-white   font-medium text-center  rounded-lg bg-neutral-50 sm:w-fit hover:bg-yellow-800 focus:ring-4 focus:outline-none focus:ring-primary-300 dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800">Send message</button>
        </form>
    </div>
  </div>
    </div>
  )
}

export default Contactuscom